// extracted by mini-css-extract-plugin
module.exports = {"Errors":"Errors_Errors__f6no3"};